module.exports = __webpack_public_path__ + "img/result-success.db5c7127.png";